import { createContext } from "react"
import type {
    AgendarNotificacaoPayload,
    AtualizarEnderecoPayload,
    NovoEnderecoPayload,
} from "../../../services/edicaoCliente"
import { EdicaoClienteInicial, EdicaoClienteModel } from "../models/edicaoClienteModel"
import { EdicaoClienteActionModel } from "./edicaoClienteActions"

type EdicaoClienteContextProps = {
    dados: EdicaoClienteModel
    dispatch: React.Dispatch<EdicaoClienteActionModel>
    erroCarregamento: string | null
    salvar: () => Promise<string>
    alterarSenha: (novaSenha: string, confirmacaoNovaSenha: string) => Promise<string>
    salvarEndereco: (idEndereco: number, payload: AtualizarEnderecoPayload) => Promise<string>
    excluirEndereco: (idEndereco: number) => Promise<string>
    adicionarEndereco: (payload: NovoEnderecoPayload) => Promise<string>
    bonificarSelos: (quantidade: number) => Promise<string>
    adicionarAoCupom: (idCupom: number) => Promise<string>
    agendarNotificacao: (payload: AgendarNotificacaoPayload) => Promise<string>
    alterarBloqueio: (bloquear: boolean) => Promise<string>
    excluirCliente: () => Promise<string>
}

const naoImplementado = async () => ""

const initialContextValue: EdicaoClienteContextProps = {
    dados: EdicaoClienteInicial,
    dispatch: () => {},
    erroCarregamento: null,
    salvar: naoImplementado,
    alterarSenha: naoImplementado,
    salvarEndereco: naoImplementado,
    excluirEndereco: naoImplementado,
    adicionarEndereco: naoImplementado,
    bonificarSelos: naoImplementado,
    adicionarAoCupom: naoImplementado,
    agendarNotificacao: naoImplementado,
    alterarBloqueio: naoImplementado,
    excluirCliente: naoImplementado,
}

export const EdicaoClienteContext = createContext<EdicaoClienteContextProps>(initialContextValue)
